<div class="card-list mat-elevation-z2">
  <ng-content></ng-content>
</div>
